export const getTimeIsLastedFrom = (startDate: string, durationInMs: number) => {
  const createdTimeInMs = new Date(startDate).valueOf();

  return createdTimeInMs + durationInMs > Date.now();
};
